// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"108":"1ffea96add7adcb1f8a2","293":"d1daa47be2f8770df9ae","452":"ae809d8c00866909bbfe"}[chunkId] + ".js";
};